var map = {
	"./account-balance.svg": "ff92",
	"./amount.svg": "2bd1",
	"./arrow-down-blue.svg": "657b",
	"./arrow-down-white.svg": "90e6",
	"./arrow-down.svg": "b95b",
	"./arrow-drop-down.svg": "ee8c",
	"./arrow-left.svg": "6873",
	"./arrow-right.svg": "6fb3",
	"./balance-white.svg": "4080",
	"./balance.svg": "cea5",
	"./building-add.svg": "7714",
	"./building.svg": "cd97",
	"./calendar.svg": "00f3",
	"./cat.svg": "6560",
	"./cloud-upload.svg": "3ce4",
	"./cloud.svg": "c004",
	"./dashboard.svg": "bab7",
	"./dot.svg": "e3b4",
	"./download.svg": "1b60",
	"./edit.svg": "cd88",
	"./error.svg": "4a3e",
	"./eye-white.svg": "7597",
	"./eye.svg": "eefd",
	"./fc.svg": "0982",
	"./filter.svg": "312d",
	"./group-users-white.svg": "c663",
	"./isOK.svg": "ab68",
	"./kyc.svg": "b2b5",
	"./list-outline.svg": "e7c5",
	"./loan-interest.svg": "9f0d",
	"./logout.svg": "343a",
	"./logs.svg": "f6e9",
	"./manual-consignations.svg": "81af",
	"./mini-filter.svg": "12df",
	"./money-change.svg": "76be",
	"./money-dispatch.svg": "1f93",
	"./money-in.svg": "62c4",
	"./money-out.svg": "a4e4",
	"./money-stats.svg": "8335",
	"./moov.svg": "8133",
	"./mtn.svg": "def8",
	"./payment-white.svg": "6032",
	"./polygon.svg": "5d3d",
	"./portefeuille-down.svg": "5066",
	"./portefeuille-entrant.svg": "a59a",
	"./portefeuille-sortant.svg": "3c20",
	"./portefeuille.svg": "e207",
	"./portefeuille2-small.svg": "be1d",
	"./portefeuille2.svg": "411b",
	"./produit.svg": "7100",
	"./rapport.svg": "a1d3",
	"./refund.svg": "615b",
	"./report-op.svg": "b5aa",
	"./report-pe.svg": "9034",
	"./reserve-credit.svg": "4ff4",
	"./trash.svg": "0d07",
	"./upload-xsl.svg": "d651",
	"./user-setting.svg": "c1df8",
	"./user-settings.svg": "25bb",
	"./users.svg": "721e",
	"./verif.svg": "05c9",
	"./xlsx-ico.svg": "4a4a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "303f";